import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8f214a0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-header"
}
const _hoisted_2 = { class: "operate-row" }
const _hoisted_3 = {
  key: 0,
  class: "page-head-right",
  href: "/help/subscribe-help",
  target: "_blank"
}
const _hoisted_4 = { class: "cm-link-light" }
const _hoisted_5 = { class: "service-category-wrap" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "category-title" }
const _hoisted_8 = {
  key: 1,
  class: "batch-box"
}
const _hoisted_9 = { class: "filter-row cm-ui-mb15" }
const _hoisted_10 = { class: "selection-bar" }
const _hoisted_11 = {
  key: 2,
  style: {"height":"24px"}
}
const _hoisted_12 = { class: "service-list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "service-info-col select-col",
  style: {"padding":"0 10px 0 0"}
}
const _hoisted_15 = { class: "service-info-col name-col" }
const _hoisted_16 = { class: "col-label" }
const _hoisted_17 = { class: "col-content name-text" }
const _hoisted_18 = { class: "service-info-col normal-col" }
const _hoisted_19 = { class: "col-label" }
const _hoisted_20 = {
  key: 0,
  class: "col-content cm-align-center"
}
const _hoisted_21 = {
  key: 1,
  class: "col-content cm-align-center"
}
const _hoisted_22 = { class: "service-info-col normal-col" }
const _hoisted_23 = {
  class: "col-label",
  style: {"margin-bottom":"3px"}
}
const _hoisted_24 = { class: "col-content" }
const _hoisted_25 = { style: {"font-size":"24px"} }
const _hoisted_26 = { class: "service-info-col normal-col" }
const _hoisted_27 = {
  class: "col-label cm-align-center",
  style: {"margin-bottom":"5px"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  class: "cm-link-light",
  href: "/help/subscribe-help",
  target: "_blank"
}
const _hoisted_30 = { class: "col-content remain-days" }
const _hoisted_31 = { style: {"color":"var(--cm-color-text-secondary)"} }
const _hoisted_32 = {
  class: "cm-align-center",
  style: {"margin-left":"auto"}
}
const _hoisted_33 = {
  key: 0,
  class: "service-info-col operate-col cm-align-center"
}
const _hoisted_34 = { class: "cm-align-center" }
const _hoisted_35 = { style: {"color":"#E54545"} }
const _hoisted_36 = { style: {"color":"#E54545"} }
const _hoisted_37 = { class: "cm-align-center" }
const _hoisted_38 = {
  key: 1,
  class: "service-info",
  style: {"background":"linear-gradient(90deg, rgba(86, 127, 255, 0.2) 0%, rgba(86, 127, 255, 0) 78.36%)"}
}
const _hoisted_39 = { class: "service-info-col name-col" }
const _hoisted_40 = { class: "name-text" }
const _hoisted_41 = {
  class: "service-info-col",
  style: {"width":"auto","font-size":"16px"}
}
const _hoisted_42 = {
  key: 3,
  class: "batch-footer"
}
const _hoisted_43 = { class: "footer-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsCards = _resolveComponent("StatisticsCards")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_CmTag = _resolveComponent("CmTag")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_ServiceAuth = _resolveComponent("ServiceAuth")!
  const _component_ServiceBatchAuth = _resolveComponent("ServiceBatchAuth")!
  const _component_BuyMoreDrawer = _resolveComponent("BuyMoreDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, {
      class: _normalizeClass(["my-subscribe-wrap important", { 'is-batching': _ctx.isBatching }])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_StatisticsCards, {
          items: _ctx.subscribeStatsCardItems,
          onItemClick: _ctx.handleStatsCardClick
        }, null, 8, ["items", "onItemClick"]),
        (!_ctx.isBatching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_el_tabs, {
                modelValue: _ctx.activeTab,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                onTabClick: _ctx.handleTabClick
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AreaTypeOption, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: index,
                      label: `${item.label}${_ctx.t('mySubscribe.zone')}`,
                      name: +item.value
                    }, null, 8, ["label", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onTabClick"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: _ctx.handleBatchSelect,
                    disabled: !_ctx.subscribeListShow.length
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.batchConfig')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]),
                  (!_ctx.hideSubscribe)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        plain: "",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/dashboard/service-subscribe?area_type=${_ctx.activeTab}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.subscribeService')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.hideSubscribe)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_3, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "assets/icons/question-solid-blue",
                        monochrome: ""
                      }),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('mySubscribe.buyHelp')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscribeListShow, (categoryItem, categoryIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["service-category cm-ui-shadow-container", { 'is-expand': categoryItem.is_expand }]),
              key: categoryItem.class_name
            }, [
              (!_ctx.isBatching)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "category-head",
                    onClick: ($event: any) => (categoryItem.is_expand = !categoryItem.is_expand)
                  }, [
                    _createVNode(_component_CmSvgIcon, {
                      style: {"margin-right":"4px"},
                      name: _ctx.ServiceGroupIcon[categoryItem.class_name?.trim()] || _ctx.ServiceGroupIcon['终端安全服务'],
                      size: 25,
                      color: "var(--el-color-primary)"
                    }, null, 8, ["name"]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.subscribeServiceGroupDisplayName(categoryItem.class_name)), 1),
                    _createVNode(_component_el_button, {
                      class: "category-toggle-btn",
                      style: {"padding":"8px","margin-left":"auto"},
                      size: "small",
                      type: "text",
                      plain: "",
                      icon: "el-icon-arrow-down",
                      round: ""
                    })
                  ], 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.isBatching && _ctx.activeTab === _ctx.AreaType.normal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_cascader, {
                        style: {"width":"220px"},
                        modelValue: _ctx.searchParams.permissionNames,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParams.permissionNames) = $event)),
                        size: "small",
                        options: _ctx.serviceOption,
                        props: { children: 'child', label: 'name', value: 'permission_names' },
                        onChange: _ctx.changeServiceOption
                      }, null, 8, ["modelValue", "options", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
                      _createVNode(_component_el_button, {
                        type: "text",
                        disabled: _ctx.isShowSelection,
                        onClick: _ctx.handleSelectAll
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isSelectAll ? _ctx.t('mySubscribe.invertSelect') : _ctx.t('mySubscribe.selectAll')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(_component_el_button, {
                        type: "text",
                        disabled: !_ctx.selectedCount,
                        onClick: _ctx.handleCancelSelect
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.cancelSelect')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(_component_el_button, {
                        type: "text",
                        disabled: !_ctx.selectedCount,
                        onClick: _ctx.toggleShowSelected
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isShowSelection ? _ctx.t('mySubscribe.close') : _ctx.t('mySubscribe.viewSelected')) + _toDisplayString(_ctx.t('mySubscribe.selected')) + "(" + _toDisplayString(_ctx.selectedCount) + ")", 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isBatching && _ctx.activeTab !== _ctx.AreaType.normal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryItem.service_list, (item, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["service-item el-card", {
              'is-expand': _ctx.expandIndex[0] === categoryIndex && _ctx.expandIndex[1] === index,
              'fee-service': item.data_type === _ctx.ServiceCost.fee,
              'bonus-service': item.data_type === _ctx.ServiceCost.bonus,
              'experience-service': item.type === _ctx.ServiceType.experience
            }]),
                    key: index
                  }, [
                    (_ctx.isPaidSubscribeRow(item))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", {
                            class: "service-info cm-align-center",
                            onClick: ($event: any) => (_ctx.handleClickService(item, categoryIndex, index))
                          }, [
                            (_ctx.isBatching)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_el_checkbox, {
                                    "model-value": !!_ctx.selectionData.find(v => v.permission_name === item.permission_name),
                                    onChange: ($event: any) => (_ctx.changeCheckbox(item))
                                  }, null, 8, ["model-value", "onChange"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('listColumns.serviceName')), 1),
                              _createVNode(_component_el_tooltip, {
                                content: _ctx.subscribeServiceDisplayName(item),
                                effect: "light",
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.subscribeServiceDisplayName(item)), 1)
                                ]),
                                _: 2
                              }, 1032, ["content"])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('mySubscribe.subscribeStatus')), 1),
                              (item.type === _ctx.ServiceType.experience)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_CmSvgIcon, {
                                      name: _ctx.ServiceStatusIcon[_ctx.ServiceStatus.trying],
                                      size: 14,
                                      monochrome: "",
                                      class: "cm-ui-mr5"
                                    }, null, 8, ["name"]),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle({color: _ctx.ServiceStatusColor[_ctx.ServiceStatus.trying]})
                                    }, _toDisplayString(_ctx.serviceStatusLabelMap[_ctx.ServiceStatus.trying]), 5)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_CmSvgIcon, {
                                      name: _ctx.ServiceStatusIcon[item.status],
                                      size: 14,
                                      monochrome: "",
                                      class: "cm-ui-mr5"
                                    }, null, 8, ["name"]),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle({color: _ctx.ServiceStatusColor[item.status]})
                                    }, _toDisplayString(_ctx.serviceStatusLabelMap[item.status]), 5)
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t('mySubscribe.configCount')), 1),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(item.count), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.t('mySubscribe.terminalUnit')), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.t('mySubscribe.serviceValidity')) + " ", 1),
                                _createVNode(_component_el_tooltip, {
                                  placement: "top",
                                  effect: "light"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.t('mySubscribe.serviceValidityTip')), 1),
                                    (!_ctx.hideSubscribe)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                          _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.seeBuyHelp')), 1),
                                          _createElementVNode("a", _hoisted_29, "《" + _toDisplayString(_ctx.t('mySubscribe.buyHelp')) + "》", 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("i", null, [
                                      _createVNode(_component_CmSvgIcon, {
                                        name: "assets/icons/warn-border-gray",
                                        monochrome: "",
                                        size: 16
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("em", null, _toDisplayString(item.expires_days), 1),
                                _createElementVNode("span", null, [
                                  _createTextVNode(_toDisplayString(_ctx.t('orderHistory.day')), 1),
                                  _createElementVNode("span", _hoisted_31, "（" + _toDisplayString(_ctx.formatTimeStamp(item.expires_time_stamp, 'YYYY-MM-DD')) + "止）", 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              (!_ctx.isBatching)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    (_ctx.isAiAssistantSubscribeItem(item))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_el_button, {
                                            size: "small",
                                            type: "primary",
                                            plain: "",
                                            onClick: _withModifiers(_ctx.openConsultRenew, ["stop"])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.consultRenew')), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"]),
                                          _createVNode(_component_el_tooltip, {
                                            effect: "light",
                                            placement: "top",
                                            content: _ctx.t('mySubscribe.noConfigTip')
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_button, {
                                                size: "small",
                                                type: "primary",
                                                disabled: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.configManage')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["content"])
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (!_ctx.hideSubscribe)
                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                key: 0,
                                                size: "small",
                                                type: "primary",
                                                plain: "",
                                                onClick: _withModifiers(($event: any) => (_ctx.toSubscribe(item)), ["stop"])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.type === _ctx.ServiceType.experience ? _ctx.t('mySubscribe.subscribeNow') : _ctx.t('mySubscribe.renewNow')), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (_ctx.IS_JP_ONLY_BUILD && _ctx.isBasicService(item))
                                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                key: 1,
                                                effect: "light",
                                                placement: "top",
                                                content: _ctx.t('mySubscribe.freeBasicNoAdjustTip')
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_button, {
                                                    size: "small",
                                                    type: "primary",
                                                    disabled: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.configManage')), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["content"]))
                                            : (item.data_type !== _ctx.ServiceCost.bonus)
                                              ? (_openBlock(), _createBlock(_component_el_button, {
                                                  key: 2,
                                                  size: "small",
                                                  type: "primary",
                                                  onClick: _withModifiers(($event: any) => (_ctx.handleAuth(item)), ["stop"])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.configManage')), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                        ], 64))
                                  ]))
                                : _createCommentVNode("", true),
                              (item.type !== _ctx.ServiceType.experience && !_ctx.isBatching)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    size: "small",
                                    style: {"padding":"8px"},
                                    type: "text",
                                    plain: "",
                                    icon: "el-icon-arrow-down",
                                    round: ""
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_13),
                          _withDirectives(_createVNode(_component_el_table, {
                            "empty-text": _ctx.$t('common.noData'),
                            class: "order-table",
                            data: item.order_list,
                            "max-height": "200"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: _ctx.t('mySubscribe.subscribeTime'),
                                prop: "create_time",
                                "min-width": "250",
                                sortable: ""
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.formatTimeStamp(scope.row.create_time)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.t('mySubscribe.subscribeCount'),
                                "min-width": "150"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("span", null, _toDisplayString(scope.row.count) + _toDisplayString(_ctx.t('mySubscribe.terminalUnit')), 1),
                                    _createTextVNode("  "),
                                    ((item.count > (_ctx.IS_PRIVATE ? item.terminal_count : scope.row.count)) && scope.row.status === _ctx.ServiceStatus.using)
                                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                          key: 0,
                                          placement: "top",
                                          effect: "light"
                                        }, {
                                          content: _withCtx(() => [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.t('mySubscribe.subscribedCount')) + "：" + _toDisplayString(_ctx.IS_PRIVATE ? item.terminal_count : scope.row.count) + _toDisplayString(_ctx.t('mySubscribe.terminalUnit')), 1),
                                            _createElementVNode("div", null, [
                                              _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.actualConfigCount')) + "：", 1),
                                              _createElementVNode("span", _hoisted_35, _toDisplayString(item.count), 1),
                                              _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.terminalUnit')), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.overLimitTip')), 1),
                                              _createElementVNode("span", _hoisted_36, _toDisplayString(scope.row.consumption_day), 1),
                                              _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.dayService')), 1)
                                            ])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_CmTag, {
                                              color: "#E34D59",
                                              border: false,
                                              "bg-color": "inherit"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.overLimit')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.t('mySubscribe.subscribeDuration'),
                                "min-width": "150"
                              }, {
                                default: _withCtx((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.cycle_count) + _toDisplayString(_ctx.dateKindLabelMap[scope.row.date_kind]), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.t('mySubscribe.remainValidity'),
                                "min-width": "220"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("span", null, _toDisplayString(scope.row.balance_day) + _toDisplayString(_ctx.t('orderHistory.day')), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.t('mySubscribe.serviceStatus'),
                                "min-width": "230"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_component_CmSvgIcon, {
                                      name: _ctx.ServiceStatusIcon[scope.row.status],
                                      size: 14,
                                      monochrome: "",
                                      class: "cm-ui-mr5"
                                    }, null, 8, ["name"]),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle({ color: _ctx.ServiceStatusColor[scope.row.status] })
                                    }, _toDisplayString(_ctx.serviceStatusLabelMap[scope.row.status]), 5),
                                    (scope.row.permission_type === _ctx.authMode.cascadeAuth)
                                      ? (_openBlock(), _createBlock(_component_el_tag, {
                                          key: 0,
                                          size: "mini",
                                          type: "warning",
                                          style: {"position":"relative","right":"-140px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.AuthLabel[_ctx.authMode.cascadeAuth]), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 2
                          }, 1032, ["empty-text", "data"]), [
                            [_vShow, _ctx.expandIndex[0] === categoryIndex && _ctx.expandIndex[1] === index]
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (item.data_type === _ctx.ServiceCost.free)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.subscribeServiceDisplayName(item)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            (_ctx.IS_JP_ONLY_BUILD)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  effect: "light",
                                  placement: "top",
                                  content: _ctx.t('mySubscribe.freeBasicNoAdjustTip')
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t('mySubscribe.freeBasicNoConfigTip')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["content"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.freeBasicNoConfigTip')), 1)
                                ], 64))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)), [
                    [_vShow, categoryItem.is_expand]
                  ])
                }), 128)),
                (!categoryItem.service_list?.length)
                  ? (_openBlock(), _createBlock(_component_EmptyData, {
                      key: 0,
                      height: "100%"
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isBatching)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("span", _hoisted_43, [
                      _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.currentSelectedService')) + " ", 1),
                      _createElementVNode("em", null, _toDisplayString(_ctx.selectionData.length), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.t('serviceSubscribe.item')), 1)
                    ]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      onClick: _ctx.cancelBatch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.cancelManage')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      disabled: !_ctx.selectionData.length,
                      onClick: _ctx.toBatchAuth
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('mySubscribe.nextStep')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          (!_ctx.subscribeListShow.length)
            ? (_openBlock(), _createBlock(_component_EmptyData, {
                key: 0,
                height: "100%"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["class"])), [
      [_directive_loading, _ctx.isLoading]
    ]),
    _createVNode(_component_ServiceAuth, {
      "service-info": _ctx.subscribeList.find(v => v.permission_name === _ctx.currentItem.permission_name),
      modelValue: _ctx.serviceAuthVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.serviceAuthVisible) = $event)),
      onSuccess: _ctx.updateData,
      "hide-subscribe": _ctx.hideSubscribe
    }, null, 8, ["service-info", "modelValue", "onSuccess", "hide-subscribe"]),
    _createVNode(_component_ServiceBatchAuth, {
      "terminal-type": _ctx.AreaTerminalTypes[_ctx.activeTab],
      "service-list": _ctx.selectionData,
      modelValue: _ctx.serviceBatchAuthVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.serviceBatchAuthVisible) = $event)),
      onSuccess: _ctx.updateData
    }, null, 8, ["terminal-type", "service-list", "modelValue", "onSuccess"]),
    _createVNode(_component_BuyMoreDrawer, {
      modelValue: _ctx.buyMoreDrawerVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.buyMoreDrawerVisible) = $event)),
      "is-private": _ctx.IS_PRIVATE || _ctx.IS_JP_ONLY_BUILD
    }, null, 8, ["modelValue", "is-private"])
  ], 64))
}